module.exports = __webpack_public_path__ + "img/Screenshot_data_format.103dd5ea.png";